import { c as _c } from "react/compiler-runtime";
import type { ApiNodeData } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import useSidebar from '@/components/playbook-builder/hooks/use-sidebar';
import { nodeMeasurementWidths } from '@/components/playbook-builder/playbook-builder.constants';
import type { NodeData } from '@/components/playbook-builder/playbook-builder.types';
import useEmployeeExperiments from '@/hooks/use-employee-experiments';
import useNodeContext from '../../../hooks/use-node-context';
import useStore from '../../../hooks/use-store';
import NodeActions from '../../node-actions-button';
import NodeCard from '../../node-card';
import type { NodeIconProps } from './node-icon';
export type BaseNodeButtonExternalProps = {
  data: NodeData<ApiNodeData>;
  subtitle: string;
  icon: NodeIconProps;
};
type BaseNodeButtonProps = BaseNodeButtonExternalProps & {
  id: string;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
};
export const BaseNodeButton = t0 => {
  const $ = _c(39);
  const {
    id,
    data,
    isActive,
    icon,
    label,
    subtitle,
    onClick
  } = t0;
  const {
    data: t1
  } = useStore();
  const {
    canEdit
  } = t1;
  const {
    removeOperation,
    nodeColorClassName,
    nodeBackgroundClassName
  } = useNodeContext(id);
  const {
    isAnyOpen
  } = useSidebar();
  const {
    isEnabled
  } = useEmployeeExperiments();
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== data.kind || $[1] !== icon || $[2] !== id || $[3] !== isActive || $[4] !== isAnyOpen || $[5] !== isEnabled || $[6] !== label || $[7] !== nodeBackgroundClassName || $[8] !== nodeColorClassName || $[9] !== onClick || $[10] !== subtitle) {
    const isDebugModeEnabled = isEnabled("playbook-builder-debug-mode");
    const color = "color" in icon ? icon.color : "primary";
    let t8;
    if ($[18] !== color || $[19] !== isActive || $[20] !== nodeColorClassName) {
      t8 = () => {
        if (isActive && !nodeColorClassName) {
          return "border-accent";
        }
        const defaultColorForNode = color === "accent" ? "border-secondary-hover" : "border-tertiary";
        return nodeColorClassName ?? defaultColorForNode;
      };
      $[18] = color;
      $[19] = isActive;
      $[20] = nodeColorClassName;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    const getBorderColorClassName = t8;
    const bgColor = nodeBackgroundClassName ?? (color === "accent" ? "bg-active" : "bg-primary");
    t7 = "group flex isolate gap-4 items-center relative";
    T0 = NodeCard;
    t2 = icon;
    t3 = label;
    t4 = isDebugModeEnabled ? id : subtitle;
    t5 = onClick;
    t6 = cx({
      "opacity-80": isAnyOpen && !isActive
    }, {
      "text-[10px]!": isDebugModeEnabled
    }, getBorderColorClassName(), bgColor, nodeMeasurementWidths[data.kind]);
    $[0] = data.kind;
    $[1] = icon;
    $[2] = id;
    $[3] = isActive;
    $[4] = isAnyOpen;
    $[5] = isEnabled;
    $[6] = label;
    $[7] = nodeBackgroundClassName;
    $[8] = nodeColorClassName;
    $[9] = onClick;
    $[10] = subtitle;
    $[11] = T0;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    T0 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
  }
  let t8;
  if ($[22] !== T0 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t8 = <T0 icon={t2} label={t3} subtitle={t4} onClick={t5} className={t6} />;
    $[22] = T0;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute left-full top-0 h-full w-8 pointer-events-none group-hover:pointer-events-auto" />;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== canEdit || $[31] !== data || $[32] !== id || $[33] !== removeOperation) {
    t10 = <NodeActions id={id} data={data} removeOperation={removeOperation} canEdit={canEdit} />;
    $[30] = canEdit;
    $[31] = data;
    $[32] = id;
    $[33] = removeOperation;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== t10 || $[36] !== t7 || $[37] !== t8) {
    t11 = <div className={t7}>{t8}{t9}{t10}</div>;
    $[35] = t10;
    $[36] = t7;
    $[37] = t8;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  return t11;
};